module.exports = __webpack_public_path__ + "img/video.d87f9f57.svg";